import { render } from "./TelegramInviteContactDialog.vue?vue&type=template&id=3e1f8714&scoped=true"
import script from "./TelegramInviteContactDialog.vue?vue&type=script&lang=js"
export * from "./TelegramInviteContactDialog.vue?vue&type=script&lang=js"

import "./TelegramInviteContactDialog.vue?vue&type=style&index=0&id=3e1f8714&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1f8714"]])

export default __exports__